let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];

class CategoryProductsService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.dataFilters = null;
    }

    getProducts(data, sales) {
        this.dataFilters = data;
        this.dataFilters.cartId = this.SessionService.get('cartId') || '';

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/show-items-by-cattegory',
                cache: false,
                data: data,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then((response) => {
                resolve(response.data);
            }, reason => {
                reject(reason);
            });
        });

    }

    getAtributos(categoriaId) {
        //this.dataFilters = data;
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/ver-atributos-de-categoria?id=' + categoriaId,
                cache: false,
                headers: {'Content-Type': 'application/json'}
            }).then((response) => {
                resolve(response.data);
            }, reason => {
                reject(reason);
            });
        });

    }

    getValoresAtributos(categoriaId, atributoId) {
        //this.dataFilters = data;
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                //url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/show-items-by-cattegory',
                url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/ver-valor-atributo-de-categoria?id=' + categoriaId + '&slug=&idAtributo=' + atributoId,
                cache: false,
                // data : data,
                headers: {'Content-Type': 'application/json'}
            }).then((response) => {
                resolve(response.data);
            }, reason => {
                reject(reason);
            });
        });

    }

    getFiltersData() {
        return this.dataFilters;
    }

    setFiltersData(dataFilters) {
        this.dataFilters = dataFilters;
    }


}

CategoryProductsService.$inject = inject;

export default CategoryProductsService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category-products/category-products.service.js
 **/